'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _publish = require('../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);
var _MyStaffUserCard = require('./MyStaffUserCard.scss');var styles = _interopRequireWildcard(_MyStaffUserCard);
var _OMButtonWithPreloader = require('../OMComponents/OMButtonWithPreloader/OMButtonWithPreloader');var _OMButtonWithPreloader2 = _interopRequireDefault(_OMButtonWithPreloader);
var _Constants = require('../../containers/MyStaffContainer/Constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

MyStaffUserFormUpdate = function (_Component) {_inherits(MyStaffUserFormUpdate, _Component);function MyStaffUserFormUpdate() {var _temp, _this, _ret;_classCallCheck(this, MyStaffUserFormUpdate);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    submitForm = function (data) {
      _this.props.editUser({ data: data, id: _this.props.id, token: _this.props.userToken });
    }, _this.

    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.submitForm)(evt);
      return true;
    }, _this.

    renderInput = function (data) {var
      translate = _this.props.translate;var
      input = data.input,label = data.label,placeholder = data.placeholder,count = data.count,type = data.type,_data$meta = data.meta,touched = _data$meta.touched,error = _data$meta.error,active = _data$meta.active;

      return (
        _react2.default.createElement('span', null,
          _react2.default.createElement('input', _extends({
            className: (0, _classnames2.default)({ 'has-error': error && !active && touched, touched: touched }, 'form-control') },
          input, {
            placeholder: placeholder || label,
            type: type })),

          _react2.default.createElement('div', { className: styles.leftWrapper },
            _react2.default.createElement('p', { className: styles.left }, translate('myStaff', 'left')),
            _react2.default.createElement('p', { className: styles.count }, count)),

          touched &&
          error && _react2.default.createElement('span', { className: styles.required }, translate('errorFieldMessages', error))));


    }, _temp), _possibleConstructorReturn(_this, _ret);}MyStaffUserFormUpdate.prototype.


  render = function render() {var _props =









    this.props,id = _props.id,translate = _props.translate,isRtl = _props.isRtl,metaStaff = _props.metaStaff,editUserLoading = _props.editUserLoading,allowed = _props.allowed,promotion = _props.promotion,top_promotion = _props.top_promotion;

    return (
      _react2.default.createElement('div', { id: id, className: styles.formWrapper },
        _react2.default.createElement('form', null,
          _react2.default.createElement('div', { className: styles.fieldsWrapper },
            _react2.default.createElement('div', { className: styles.fieldWrapper },
              _react2.default.createElement('p', { className: styles.nameFiled }, translate('myStaff', 'properties')),
              _react2.default.createElement(_reduxForm.Field, {
                name: _Constants.FIELD_NAMES.PUBLISH_LIMIT,
                component: this.renderInput,
                type: 'tel',
                inputmode: 'numeric',
                pattern: '[0-9]*',
                placeholder: translate('myStaff', 'num'),
                normalize: _publish2.default.numbers,
                isRtl: isRtl,
                count: allowed + metaStaff.canAddProperties })),


            _react2.default.createElement('div', { className: styles.fieldWrapper },
              _react2.default.createElement('p', { className: styles.nameFiled }, translate('myStaff', 'highlights')),
              _react2.default.createElement(_reduxForm.Field, {
                name: _Constants.FIELD_NAMES.COLOR_PROMOTION_LIMIT,
                component: this.renderInput,
                type: 'tel',
                inputmode: 'numeric',
                pattern: '[0-9]*',
                placeholder: translate('myStaff', 'num'),
                normalize: _publish2.default.numbers,
                isRtl: isRtl,
                count: promotion + metaStaff.canAddColorPromotions })),


            _react2.default.createElement('div', { className: styles.fieldWrapper },
              _react2.default.createElement('p', { className: styles.nameFiled }, translate('myStaff', 'top')),
              _react2.default.createElement(_reduxForm.Field, {
                name: _Constants.FIELD_NAMES.TOP_PROMOTION_LIMIT,
                component: this.renderInput,
                type: 'tel',
                inputmode: 'numeric',
                pattern: '[0-9]*',
                placeholder: translate('myStaff', 'num'),
                normalize: _publish2.default.numbers,
                isRtl: isRtl,
                count: top_promotion + metaStaff.canAddTopPromotions }))),



          _react2.default.createElement('div', { className: styles.btnSubmit },
            _react2.default.createElement(_OMButtonWithPreloader2.default, {
              showPreloader: editUserLoading,
              onClick: this.handleSubmit,
              innerText: translate('myStaff', 'send') })))));





  };return MyStaffUserFormUpdate;}(_react.Component);


MyStaffUserFormUpdate.propTypes = {
  translate: _propTypes2.default.func,
  editUser: _propTypes2.default.func,
  id: _propTypes2.default.string,
  userToken: _propTypes2.default.string,
  handleSubmit: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  allowed: _propTypes2.default.number,
  promotion: _propTypes2.default.number,
  top_promotion: _propTypes2.default.number,
  editUserLoading: _propTypes2.default.bool,
  loadUserProperties: _propTypes2.default.func,
  metaStaff: _propTypes2.default.shape({
    canAddProperties: _propTypes2.default.number,
    canAddColorPromotions: _propTypes2.default.number,
    canAddTopPromotions: _propTypes2.default.number }).
  isRequired };exports.default =


MyStaffUserFormUpdate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MyStaffUserCard/MyStaffUserFormUpdate.js
// module id = 2717
// module chunks = 0